import { render, staticRenderFns } from "./SamTableColumn.vue?vue&type=template&id=4d20c7a8&scoped=true&"
import script from "./SamTableColumn.vue?vue&type=script&lang=js&"
export * from "./SamTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./SamTableColumn.vue?vue&type=style&index=0&id=4d20c7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20c7a8",
  null
  
)

export default component.exports